export class Material{
    
    public itemID:any;
    public contenedorACompraConfig:number=1;
    public contenedorAVentaConfig:number;
    
    // -----------  Compra ----------------------------- //
    public ITEM_ID_COMPRA:any;
    public ITEM_FAMILY_ID_COMPRA:any;
    public ITEM_SUBFAMILY_ID_COMPRA:any;
    public searchProductCompra:any;
    public UNITS_PER_CONTAINER_COMPRA:any;
    public MINIMUM_UNIT_NAME_COMPRA:any;
    public CONTAINER_NAME_COMPRA:any;
    //Listas para área Compra
    public lstFamiliaCompra=[];
    public lstSubFamiliaCompra=[];
    public lstProductCompra=[];
    public lstProductoFiltradasCompra=[];


    // -----------  VENTA ----------------------------- //
    public ITEM_ID_VENTA:any;
    public ITEM_FAMILY_ID_VENTA:any;
    public ITEM_SUBFAMILY_ID_VENTA:any;
    public searchProductVenta:any;
    public UNITS_PER_CONTAINER_VENTA:any;
    public MINIMUM_UNIT_NAME_VENTA:any;
    public CONTAINER_NAME_VENTA:any;
    //Listas para área VENTA
    public lstFamiliaVenta=[];
    public lstSubFamiliaVenta=[];
    public lstProductVenta=[];
    public lstProductoFiltradasVenta=[];
}


// WEBPACK FOOTER //
// ./src/app/models/materiales.ts